
<h1 mat-dialog-title>{{data.title}}</h1>
<div mat-dialog-content [innerHTML]="data.content | safeHtml"></div>
<div mat-dialog-actions>
  <button class="btn btn-primary" mat-button mat-dialog-close>Chiudi</button>
</div>
